// Klaviyo Form Events
window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'open') {
        /*rudderanalytics.track('Sign Up Form View', {
            formId: e.detail.formId
        })*/
        gtag('event', 'sign_up_form_view', {
            'event_category': 'Lead Form',
            'event_action': 'View Klaviyo Form',
            'event_label': e.detail.formId
        })
    } 
    if (e.detail.type == 'submit') {
        var _learnq = window._learnq || [];
        var url_visit = window.location.pathname;
        _learnq.push(['identify', {'URL Visited' : url_visit}]);
        gtag('event', 'conversion', {'send_to': 'AW-777375651/-sKQCNHA5pEZEKOf1_IC'});
        fbq('track','Lead');
        /*rudderanalytics.track('Email Sign Up', {
            formId: e.detail.formId,
            formSource: e.detail.metaData.$source, 
            email: e.detail.metaData.$email,
        });*/
        gtag('event', 'email_sign_up', {
            'event_category': 'Lead Form',
            'event_action': 'Sumbit Klaviyo Form',
            'event_label': e.detail.formId,
            formSource: e.detail.metaData.$source
        })
    }
});
// Product Added to Cart Event
document.addEventListener('variant:added', function(e) {
    var variant = e.detail.variant;
    var item = {
        id: variant.id,
        name: variant.product_title,
        type: variant.product_type,
        url: variant.url,
        productType: variant.product_type,
        imageUrl: variant.image,
        variantSelected: variant.variant_id,
        price: variant.price,
        priceMin: variant.discount_price,
        priceMax: variant.original_price,
        sale: variant.discount_price,
        value: Math.round(variant.price)/100,

    };
    _learnq.push(['track', 'Product Added', item]);
});
// Cart Updated Event + Start Checkout Event Listener
document.addEventListener('cart:updated', function(e) {
    /*let cart = e.detail.cart;
    rudderanalytics.track('Cart Updated', {
        itemCount: cart.item_count,
	      cartSubtotal: cart.items_subtotal_price,
	      cartCurrency: cart.currency,
	      totalPrice: cart.total_price,
	      cartItems: cart.items
    })*/
});
// Mobile nav open and close events
document.addEventListener('mobile-nav:open', function() {
    //rudderanalytics.track('Mobile Nav Open');
});
document.addEventListener('mobile-nav:close', function() {
    //rudderanalytics.track('Mobile Nav Close');
});
// Cart and Quick View open + close
document.addEventListener('openable-element:open', function(e) {
    let element = e.target.tagName;
    //console.log(e.detail);
    if(element === 'CART-DRAWER') {
        //rudderanalytics.track('Mini Cart Open');
        gtag('event', 'mini_cart_open', {
            'event_category': 'Cart',
            'event_action': 'Open Mini Cart',
            'event_label': window.location.pathname
        })
    }
    if(element === 'QUICK-BUY-POPOVER') {
        //rudderanalytics.track('Mobile Quick View Open');
        gtag('event', 'quick_view_open', {
            'event_category': 'Quick View',
            'event_action': 'Mobile Quick View Open',
            'event_label': window.location.pathname
        })
    }
    if(element === 'QUICK-BUY-DRAWER') {
        //rudderanalytics.track('Desktop Quick View Open');
        gtag('event', 'quick_view_open', {
            'event_category': 'Quick View',
            'event_action': 'Desktop Quick View Open',
            'event_label': window.location.pathname
        })
    }
});
document.addEventListener('openable-element:close', function(e) {
    let element = e.target.tagName;
    if(element === 'CART-DRAWER') {
        //rudderanalytics.track('Mini Cart Close');
        gtag('event', 'mini_cart_close', {
            'event_category': 'Cart',
            'event_action': 'Close Mini Cart',
            'event_label': window.location.pathname
        })
    }
    if(element === 'QUICK-BUY-POPOVER') {
        //rudderanalytics.track('Quick View Close');
        gtag('event', 'quick_view_close', {
            'event_category': 'Quick View',
            'event_action': 'Mobile Quick View Close',
            'event_label': window.location.pathname
        })
    }
    if(element === 'QUICK-BUY-DRAWER') {
        //rudderanalytics.track('Quick View Close');
        gtag('event', 'quick_view_close', {
            'event_category': 'Quick View',
            'event_action': 'Desktop Quick View Close',
            'event_label': window.location.pathname
        })
    }
});
// Mini Cart Discount Codes
let discountCode = "";
let miniCart = document.querySelector('#shopify-section-mini-cart');
miniCart?.addEventListener('input', (e) => {
    if(e.target.id == 'discount_code') {
        discountCode = e.target.value;
    }
  });
miniCart?.addEventListener('click', (e) => {
    if(e.target.id == 'apply_discount') {
        e.target.innerHTML = 'APPLYING';
        e.target.disabled = true;
        applyDiscount(discountCode);
    }
})
function applyDiscount(code) {
    fetch(`/discount/${code}`)
    .then(function() {
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            updates: {},
            }),
        });
    })
    .finally(function() {document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }),);})
    .catch(error => console.error('Error:', error));
};
// Add to Wishlist btn click
const wishlistBtn = document.querySelector(".quantum-lbw-wishlist-btn");
if (wishlistBtn) {
        wishlistBtn.addEventListener('click', function(e) {
        const product_id = e.target.getAttribute("data-quantum-lbw-product-id");
        const currentUrl = window.location.href;
        const item = {id: product_id, url: currentUrl};
        _learnq.push(['track', 'Wish List Add', item]);
        /*rudderanalytics.track('Wish List Add', {
            id: product_id,
            url: currentUrl
        });*/
    })
}
// Page has loaded and theme assets are ready
window.addEventListener('pageshow', function() {
    // console.log('Page loaded and theme assets are ready')
    var isBrowser = new Function("try {return this===window;}catch(e){ return false;}");
    if (isBrowser() && !navigator.userAgent.includes("Linux x86_64")) {
        window['_fs_host'] = 'fullstory.com';
        window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
        window['_fs_org'] = 'o-22KHBE-na1';
        window['_fs_namespace'] = 'FS';
        !function(m,n,e,t,l,o,g,y){var s,f,a=function(h){
        return!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'),!1)}(e)
        ;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}
        d&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{
        then:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){
        h(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,""),"function"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)}
        ;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){
        "function"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){
        (o=n.createElement(t)).async=!0,o.crossOrigin="anonymous",o.src="https://"+l,o.onerror=function(){y("Error loading "+l)}
        ;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){}
        function h(b,h,d){g(b,h,d,1)}function d(b,d,j){h("setProperties",{type:b,properties:d},j)}function j(b,h){d("user",b,h)}function r(b,h,d){j({
        uid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h("trackEvent",{
        name:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h("shutdown")},g.restart=function(){h("restart")},
        g.log=function(b,d){h("log",{level:b,msg:d})},g.consent=function(b){h("setIdentity",{consent:!arguments.length||b})}}(),s="fetch",
        f="XMLHttpRequest",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v="2.0.0")
        }(window,document,window._fs_namespace,"script",window._fs_script);
    }
});
